/**
 * Math4Sale Shopify Theme JS
 * Handles: mobile menu, accordion, animated counters, carousel, product forms, quantity controls
 */

(function () {
  'use strict';

  /* =========================================
   * Mobile Menu Toggle
   * ========================================= */
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        menu.classList.toggle('hidden');
      }
    });
  });

  /* =========================================
   * Accordion (FAQ)
   * ========================================= */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var items = accordion.querySelectorAll('[data-accordion-item]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var content = item.querySelector('[data-accordion-content]');
      var chevron = item.querySelector('[data-accordion-chevron]');

      if (!trigger || !content) return;

      // Initialize open items
      if (item.hasAttribute('data-accordion-open')) {
        trigger.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
        if (chevron) chevron.style.transform = 'rotate(180deg)';
      }

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // Close all
        items.forEach(function (otherItem) {
          var otherTrigger = otherItem.querySelector('[data-accordion-trigger]');
          var otherContent = otherItem.querySelector('[data-accordion-content]');
          var otherChevron = otherItem.querySelector('[data-accordion-chevron]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherContent) otherContent.style.maxHeight = '0';
          if (otherChevron) otherChevron.style.transform = 'rotate(0deg)';
        });

        // Toggle current
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
          if (chevron) chevron.style.transform = 'rotate(180deg)';
        }
      });
    });
  });

  /* =========================================
   * Animated Counters
   * ========================================= */
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCounter(el) {
    var target = parseInt(el.dataset.target, 10);
    if (isNaN(target)) return;
    var suffix = el.textContent.replace(/[\d,]/g, '').trim() || '+';
    var duration = 1200;
    var startTime = performance.now();

    function animate(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var value = Math.floor(easeOutCubic(progress) * target);
      el.textContent = value.toLocaleString() + suffix;
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        el.textContent = target.toLocaleString() + suffix;
      }
    }

    requestAnimationFrame(animate);
  }

  // Observe counters
  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  document.querySelectorAll('[data-counter]').forEach(function (el) {
    counterObserver.observe(el);
  });

  /* =========================================
   * Testimonials Carousel
   * ========================================= */
  document.querySelectorAll('[data-testimonial-carousel]').forEach(function (carousel) {
    var prevBtn = carousel.closest('section').querySelector('[data-carousel-prev]');
    var nextBtn = carousel.closest('section').querySelector('[data-carousel-next]');
    var progressBar = carousel.closest('section').querySelector('[data-carousel-progress]');

    function updateProgress() {
      if (!progressBar) return;
      var max = carousel.scrollWidth - carousel.clientWidth;
      var progress = max > 0 ? (carousel.scrollLeft / max) * 100 : 0;
      progressBar.style.width = Math.max(25, progress) + '%';
    }

    carousel.addEventListener('scroll', updateProgress);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: -320, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: 320, behavior: 'smooth' });
      });
    }
  });

  /* =========================================
   * Quantity Controls
   * ========================================= */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('div').querySelector('[data-qty-input]');
      if (input && parseInt(input.value, 10) > 1) {
        input.value = parseInt(input.value, 10) - 1;
        input.dispatchEvent(new Event('change'));
        updateSubtotal();
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('div').querySelector('[data-qty-input]');
      if (input) {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change'));
        updateSubtotal();
      }
    });
  });

  /* =========================================
   * Product Variant Selection
   * ========================================= */

  // Returns true if variantCondition satisfies selectedCondition display label
  function conditionMatches(variantCondition, selectedCondition) {
    if (variantCondition === selectedCondition) return true;
    var vCond = (variantCondition || '').toLowerCase();
    var sCond = (selectedCondition || '').toLowerCase();
    if (sCond.indexOf('factory renewed') >= 0) {
      return vCond.indexOf('renewed') >= 0 || vCond.indexOf('reconditioned') >= 0 || vCond.indexOf('refurbished') >= 0;
    }
    if (sCond.indexOf('institutional') >= 0 || sCond.indexOf('open box') >= 0) {
      return vCond.indexOf('open box') >= 0 && vCond.indexOf('retail') < 0;
    }
    if (sCond.indexOf('retail') >= 0) {
      return vCond.indexOf('retail') >= 0 && vCond.indexOf('new') >= 0;
    }
    return false;
  }

  // Currently active edition, or null when the product has no linked editions
  function getSelectedEdition() {
    var active = document.querySelector('[data-edition-btn].border-m4s-blue');
    return active ? active.dataset.edition : null;
  }

  // Shows only the thumbnail strip belonging to the given edition
  function showEditionGallery(edition) {
    var galleries = document.querySelectorAll('[data-edition-gallery]');
    if (!galleries.length) return;
    galleries.forEach(function (gallery) {
      gallery.style.display = gallery.dataset.editionGallery === edition ? 'flex' : 'none';
    });
  }

  // Reads data-option-<n> attributes written by Liquid to discover option positions
  function getOptionIndices() {
    var meta = document.getElementById('product-variant-meta');
    var colorIdx = 2;
    var conditionIdx = 1;
    if (meta) {
      if (meta.dataset.optionColor) colorIdx = parseInt(meta.dataset.optionColor, 10);
      else if (meta.dataset.optionStyle) colorIdx = parseInt(meta.dataset.optionStyle, 10);
      if (meta.dataset.optionCondition) conditionIdx = parseInt(meta.dataset.optionCondition, 10);
    }
    return { colorIdx: colorIdx, conditionIdx: conditionIdx };
  }

  // Highlights the thumbnail whose URL matches imgSrc, deactivates all others
  function updateActiveThumbnail(imgSrc) {
    document.querySelectorAll('[data-thumbnail]').forEach(function (thumb) {
      var isActive = thumb.dataset.thumbnail === imgSrc;
      if (isActive) {
        thumb.classList.remove('border-border', 'hover:border-m4s-blue/50');
        thumb.classList.add('border-m4s-blue', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.2)]');
      } else {
        thumb.classList.remove('border-m4s-blue', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.2)]');
        thumb.classList.add('border-border', 'hover:border-m4s-blue/50');
      }
    });
  }

  // Updates each condition card's price (and availability) for the current edition + color
  function updateConditionPrices() {
    var select = document.querySelector('[data-variant-select]');
    if (!select) return;

    var indices = getOptionIndices();
    var colorIdx = indices.colorIdx;
    var conditionIdx = indices.conditionIdx;
    var selectedEdition = getSelectedEdition();

    // Determine the currently active color value (if any color option exists)
    var selectedColor = null;
    document.querySelectorAll('[data-option-value]').forEach(function (btn) {
      var name = btn.dataset.optionName;
      if (name === 'Color' || name === 'Style') {
        if (btn.classList.contains('border-m4s-blue') || btn.classList.contains('scale-110')) {
          selectedColor = btn.dataset.optionValue;
        }
      }
    });

    var allOptions = select.querySelectorAll('option');

    document.querySelectorAll('[data-option-name="Condition"]').forEach(function (card) {
      var condValue = card.dataset.optionValue;
      var priceEl = card.querySelector('[data-condition-price]');
      var nameEl = card.querySelector('.text-sm.font-bold');
      var isSelected = card.classList.contains('border-m4s-blue');

      // Find the variant for [selected edition + selected color + this condition]
      var matchedOpt = null;
      for (var i = 0; i < allOptions.length; i++) {
        var opt = allOptions[i];
        if (selectedEdition && opt.dataset.edition !== selectedEdition) continue;
        if (!conditionMatches(opt.dataset['option' + conditionIdx], condValue)) continue;
        if (selectedColor !== null && opt.dataset['option' + colorIdx] !== selectedColor) continue;
        matchedOpt = opt;
        break;
      }

      if (matchedOpt) {
        var price = parseInt(matchedOpt.dataset.price, 10) || 0;
        if (priceEl) {
          priceEl.textContent = '$' + (price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          priceEl.className = 'text-sm text-foreground';
        }
        card.disabled = false;
        card.style.opacity = '';
        if (!isSelected) {
          card.classList.remove('border-m4s-blue', 'bg-blue-50', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.15)]', 'bg-gray-50', 'cursor-not-allowed');
          card.classList.add('border-border', 'bg-white', 'hover:border-m4s-blue/40', 'hover:bg-blue-50/50');
        }
        if (nameEl) {
          nameEl.classList.remove('text-gray-400');
          if (!isSelected) nameEl.classList.add('text-foreground');
        }
      } else {
        if (priceEl) {
          priceEl.textContent = 'Not available';
          priceEl.className = 'text-sm text-muted-foreground italic';
        }
        card.disabled = true;
        card.style.opacity = '0.5';
        card.classList.remove('border-m4s-blue', 'bg-blue-50', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.15)]', 'bg-white', 'hover:border-m4s-blue/40', 'hover:bg-blue-50/50');
        card.classList.add('border-border', 'bg-gray-50', 'cursor-not-allowed');
        if (nameEl) {
          nameEl.classList.remove('text-foreground', 'text-m4s-blue');
          nameEl.classList.add('text-gray-400');
        }
      }
    });
  }

  document.querySelectorAll('[data-option-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionName = btn.dataset.optionName;
      var optionValue = btn.dataset.optionValue;

      // Update visual state for sibling buttons
      var siblings = btn.parentElement.querySelectorAll('[data-option-name="' + optionName + '"]');
      siblings.forEach(function (sib) {
        if (optionName === 'Condition') {
          sib.classList.remove('border-m4s-blue', 'bg-blue-50', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.15)]');
          sib.classList.add('border-border', 'bg-white');
          sib.querySelector('.text-sm.font-bold')?.classList.remove('text-m4s-blue');
          sib.querySelector('.text-sm.font-bold')?.classList.add('text-foreground');
        } else {
          sib.classList.remove('border-m4s-blue', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.2)]', 'scale-110');
          sib.classList.add('border-border');
        }
      });

      // Highlight selected
      if (optionName === 'Condition') {
        btn.classList.remove('border-border', 'bg-white');
        btn.classList.add('border-m4s-blue', 'bg-blue-50', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.15)]');
        btn.querySelector('.text-sm.font-bold')?.classList.remove('text-foreground');
        btn.querySelector('.text-sm.font-bold')?.classList.add('text-m4s-blue');
      } else {
        btn.classList.remove('border-border');
        btn.classList.add('border-m4s-blue', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.2)]', 'scale-110');
        var colorLabel = document.querySelector('[data-selected-color]');
        if (colorLabel) colorLabel.textContent = optionValue;
      }

      // Find and select matching variant
      updateSelectedVariant();
    });
  });

  /* =========================================
   * Edition switching — swaps eligible variants and the gallery
   * ========================================= */
  document.querySelectorAll('[data-edition-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-edition-btn]').forEach(function (sib) {
        sib.classList.remove('border-m4s-blue', 'bg-blue-50', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.15)]');
        sib.classList.add('border-border', 'bg-white');
        var sibLabel = sib.querySelector('.text-sm.font-bold');
        if (sibLabel) {
          sibLabel.classList.remove('text-m4s-blue');
          sibLabel.classList.add('text-foreground');
        }
      });

      btn.classList.remove('border-border', 'bg-white');
      btn.classList.add('border-m4s-blue', 'bg-blue-50', 'shadow-[0_0_0_3px_hsl(var(--blue)/0.15)]');
      var label = btn.querySelector('.text-sm.font-bold');
      if (label) {
        label.classList.remove('text-foreground');
        label.classList.add('text-m4s-blue');
      }

      // Swap the thumbnail strip to this edition's images
      showEditionGallery(btn.dataset.edition);

      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var select = form.querySelector('[data-variant-select]');
    if (!select) return;

    var indices = getOptionIndices();
    var selectedEdition = getSelectedEdition();

    // Gather selected options from active buttons
    var selectedOptions = {};
    document.querySelectorAll('[data-option-value]').forEach(function (btn) {
      var name = btn.dataset.optionName;
      if (name === 'Condition') {
        if (btn.classList.contains('border-m4s-blue')) selectedOptions[name] = btn.dataset.optionValue;
      } else {
        if (btn.classList.contains('border-m4s-blue') || btn.classList.contains('scale-110')) selectedOptions[name] = btn.dataset.optionValue;
      }
    });

    // Find the <option> that matches the edition and all selected dimensions
    var options = select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (selectedEdition && opt.dataset.edition !== selectedEdition) continue;

      var match = true;
      for (var key in selectedOptions) {
        var optIdx = key === 'Condition' ? indices.conditionIdx : (key === 'Color' || key === 'Style') ? indices.colorIdx : 1;
        var variantValue = opt.dataset['option' + optIdx];
        var selectedValue = selectedOptions[key];
        if (key === 'Condition') {
          if (!conditionMatches(variantValue, selectedValue)) { match = false; break; }
        } else {
          if (variantValue !== selectedValue) { match = false; break; }
        }
      }
      if (match) {
        select.value = opt.value;

        // Update main product image to this variant's featured image
        if (opt.dataset.image) {
          var imgEl = document.getElementById('product-main-image');
          if (imgEl) {
            imgEl.src = opt.dataset.image;
            updateActiveThumbnail(opt.dataset.image);
          }
        }

        updateSubtotal();
        break;
      }
    }

    // Always refresh condition card prices for the current edition/color selection
    updateConditionPrices();
  }

  function updateSubtotal() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var select = form.querySelector('[data-variant-select]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var subtotalEl = document.querySelector('[data-subtotal]');
    var qtyDisplay = document.querySelector('[data-qty-display]');
    var qtyPlural = document.querySelector('[data-qty-plural]');

    if (!select || !qtyInput) return;

    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    var price = parseInt(selectedOption.dataset.price, 10) || 0;
    var qty = parseInt(qtyInput.value, 10) || 1;
    var total = price * qty;

    if (subtotalEl) {
      subtotalEl.textContent = '$' + (total / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    if (qtyDisplay) qtyDisplay.textContent = qty;
    if (qtyPlural) qtyPlural.textContent = qty !== 1 ? 's' : '';

    // Keep Quotify in sync — variant AND product, so cross-edition quotes resolve correctly
    var quotifyBtn = document.querySelector('[data-quotify]');
    if (quotifyBtn) {
      quotifyBtn.setAttribute('data-variant', selectedOption.value);

      var ed = selectedOption.dataset.edition;
      if (ed) {
        var payloadEl = document.querySelector('[data-edition-payload="' + ed.replace(/"/g, '\\"') + '"]');
        if (payloadEl) {
          try {
            var payload = JSON.parse(payloadEl.textContent);
            quotifyBtn.setAttribute('data-product-id', payload.productId);
            quotifyBtn.setAttribute('data-product', JSON.stringify(payload.product));
          } catch (e) {
            /* leave the server-rendered values in place */
          }
        }
      }
    }
  }

  /* =========================================
   * Initialize product page on load
   * ========================================= */
  if (document.querySelector('[data-product-form]')) {
    updateSubtotal();
    updateConditionPrices();
  }

  /* =========================================
   * Scroll to top on page navigation
   * ========================================= */
  window.scrollTo(0, 0);
})();
